import { render, staticRenderFns } from "./RulesByGroupFilter.vue?vue&type=template&id=ebc89bd4"
import script from "./RulesByGroupFilter.vue?vue&type=script&lang=js"
export * from "./RulesByGroupFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports